import React from "react";
import KC_Heading3 from "../../../../../designsystem/typography/KC-Heading/KC_Heading3";
import KC_Card from "../../../../../designsystem/KC_Card/KC_Card";
import { KC_PaddingEnum } from "../../../../../designsystem/KC_Card/component/model/KC_PaddingEnum";
import { tt } from "../../../../../utils/i18n/i18n";
import type { TranslationsKeys } from "../../../../../utils/i18n/translations/Translations";

interface LoyaltyRewardEditorPageLayoutProps {
  titleKey: keyof TranslationsKeys;
  id?: string;
  className?: string;
  contentClassName?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

export const LoyaltyRewardEditorPageLayout = ({
  titleKey,
  id,
  className,
  contentClassName,
  style,
  children
}: LoyaltyRewardEditorPageLayoutProps) => {
  return (
    <div
      id={id}
      className={`d-flex st-gap flex-column dashboard-v2${
        className ? ` ${className}` : ""
      }`}
      style={style}
    >
      <div className="px-4 pt-4 d-flex flex-column st-gap">
        <KC_Heading3 text={tt(titleKey)} />
      </div>
      <div className={contentClassName}>{children}</div>
    </div>
  );
};

interface LoyaltyRewardCardLayoutProps {
  icon: React.ReactNode;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  rightHeader?: React.ReactNode;
  primaryAction?: React.ReactNode;
  children?: React.ReactNode;
  cardClassName?: string;
  cardId?: string;
}

export const LoyaltyRewardCardLayout = ({
  icon,
  title,
  subtitle,
  rightHeader,
  primaryAction,
  children,
  cardClassName,
  cardId
}: LoyaltyRewardCardLayoutProps) => {
  const cardClassNames = [
    "flex-grow-1",
    "loyalty-gift-editor-card",
    cardClassName
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <KC_Card
      id={cardId}
      padding={KC_PaddingEnum.gift}
      boxShadow={true}
      isGiftCard={true}
      className={cardClassNames}
    >
      <div className="loyalty-gift-editor-card__inner">
        <div className="loyalty-gift-editor-card__header">
          <div className="loyalty-gift-editor-card__header-left">
            {icon}
            {(title || subtitle) && (
              <div className="d-flex flex-column" style={{ gap: 2 }}>
                {title}
                {subtitle}
              </div>
            )}
          </div>
          <div className="loyalty-gift-editor-card__header-right">
            {rightHeader}
          </div>
        </div>
        {primaryAction}
        {children}
      </div>
    </KC_Card>
  );
};

